export interface NavItem { label: string; path: string; icon: string; children?: NavItem[] }
export interface NavSection { section: string; items: NavItem[] }

export const adminNav: NavSection[] = [
  {
    section: 'OVERVIEW',
    items: [
      { label: 'Dashboard',     path: '/dashboard',                icon: 'LayoutDashboard' },
    ],
  },
  {
    section: 'OPERATIONS',
    items: [
      { label: 'To-Do', path: '/dashboard/todo/verification', icon: 'CheckSquare', children: [
          { label: 'Pending Verification', path: '/dashboard/todo/verification',              icon: '' },
          { label: 'Profile Picture Update Request', path: '/dashboard/todo/trainer-profile-updates', icon: '' },
          { label: 'Profile Change Logs',   path: '/dashboard/todo/trainer-profile-updates/logs', icon: '' },
      ]},
      { label: 'Users', path: '/dashboard/user/list', icon: 'Users', children: [
          { label: 'User List',    path: '/dashboard/user/list', icon: '' },
          { label: 'Create User',  path: '/dashboard/user/new',  icon: '' },
      ]},
      { label: 'School Management', path: '/dashboard/school/list',        icon: 'School' },
      { label: 'Vehicle Category',  path: '/dashboard/category',          icon: 'Car' },
      { label: 'Bookings', path: '/dashboard/booking/list', icon: 'Calendar', children: [
          { label: 'Booking List', path: '/dashboard/booking/list',  icon: '' },
          // Refunds hidden for now — re-add { label: 'Refunds', path: '/dashboard/booking/refund', icon: '' } to restore.
          { label: 'Change Trainer History', path: '/dashboard/booking/change-trainer-history', icon: '' },
          { label: 'Booking Tracking', path: '/dashboard/booking/tracking', icon: '' },
          { label: 'Reassignment Issues', path: '/dashboard/booking/auto-reassign-issues', icon: '' },
          { label: 'Reassignment History', path: '/dashboard/booking/auto-reassign-history', icon: '' },
      ]},
      { label: 'Assistant Bookings', path: '/dashboard/assistant-bookings', icon: 'CreditCard' },
    ],
  },
  {
    section: 'FINANCE',
    items: [
      { label: 'Payouts', path: '/dashboard/payouts/trainer', icon: 'Wallet', children: [
          { label: 'Trainer Payouts',   path: '/dashboard/payouts/trainer',    icon: '' },
          { label: 'Payout Requests',   path: '/dashboard/payouts/requests',   icon: '' },
      ]},
      { label: 'Student Wallet Balances', path: '/dashboard/wallet/students', icon: 'Coins' },
      { label: 'Withdrawal Requests', path: '/dashboard/wallet/withdrawals', icon: 'Banknote' },
      { label: 'Certificate', path: '/dashboard/awaiting-certificate', icon: 'BadgeCheck', children: [
          { label: 'Awaiting Certificate', path: '/dashboard/awaiting-certificate', icon: '' },
          { label: 'Approved Certificate', path: '/dashboard/approved-certificate', icon: '' },
      ]},
      { label: 'Reports & Analytics', path: '/dashboard/report/bookings', icon: 'BarChart2', children: [
          { label: 'Booking Report', path: '/dashboard/report/bookings', icon: '' },
          { label: 'Revenue Report', path: '/dashboard/report/revenue',  icon: '' },
          { label: 'Trainer Report', path: '/dashboard/report/trainer',  icon: '' },
          { label: 'Student Report', path: '/dashboard/report/student',  icon: '' },
          { label: 'School Report',  path: '/dashboard/report/school',   icon: '' },
      ]},
    ],
  },
  {
    section: 'CATALOG & MARKETING',
    items: [
      { label: 'Package Management',   path: '/dashboard/package/list',                 icon: 'Package' },
      { label: 'All-in-One Package',   path: '/dashboard/all-in-one',                   icon: 'Layers', children: [
          { label: 'Bundles',      path: '/dashboard/all-in-one',             icon: '' },
          { label: 'Enrollments',  path: '/dashboard/all-in-one/enrollments', icon: '' },
      ]},
      { label: 'Coupon Management',    path: '/dashboard/coupon/list',                  icon: 'Tag' },
      { label: 'Service Registrations',path: '/dashboard/dynamic-service/registrations',icon: 'ClipboardList' },
      { label: 'Home Slider',          path: '/dashboard/home-slider/list',             icon: 'Image' },
    ],
  },
  {
    section: 'ENGAGEMENT',
    items: [
      { label: 'Reviews', path: '/dashboard/review/trainer', icon: 'Star', children: [
          { label: 'Trainer Reviews', path: '/dashboard/review/trainer', icon: '' },
          { label: 'Student Reviews', path: '/dashboard/review/student', icon: '' },
      ]},
      { label: 'Notifications',        path: '/dashboard/notifications',                icon: 'Bell' },
      { label: 'Support',             path: '/dashboard/support',                      icon: 'HeadphonesIcon' },
    ],
  },
  {
    section: 'ADMINISTRATION',
    items: [
      { label: 'Delete Users',         path: '/dashboard/tracking',                     icon: 'UserMinus' },
      { label: 'Roles & Permissions', path: '/dashboard/roles-and-permission/roles', icon: 'Shield', children: [
          { label: 'Roles & Access', path: '/dashboard/roles-and-permission/roles', icon: '' },
          { label: 'User Roles',     path: '/dashboard/roles-and-permission/users', icon: '' },
      ]},
      { label: 'System Settings', path: '/dashboard/system/language', icon: 'Settings', children: [
          { label: 'Languages',        path: '/dashboard/system/language',        icon: '' },
          { label: 'Cities',           path: '/dashboard/system/city',            icon: '' },
          { label: 'States',           path: '/dashboard/system/state',           icon: '' },
          { label: 'Dialects',         path: '/dashboard/system/dialect',         icon: '' },
          { label: 'Pickup Time Restriction', path: '/dashboard/system/pickup',   icon: '' },
          { label: 'App Settings',     path: '/dashboard/system/app-settings',    icon: '' },
          { label: 'Terms & Conditions',path:'/dashboard/system/terms-conditions',icon: '' },
          { label: 'Dynamic Services', path: '/dashboard/system/dynamic-services',icon: '' },
          { label: 'Auto-Reassign',    path: '/dashboard/system/auto-reassign',   icon: '' },
      ]},
    ],
  },
]

// ── Platform-admin permission visibility ─────────────────────────────────────
// Keyed by nav label. The value is what the admin must hold (from who-am-i `permissions`) to see
// the item: an endpoint key, or 'GET /admin/<section>/*' for "can read that area". An array means
// any-of. Items NOT listed here are always shown. A parent is shown while any child is.
export const adminNavPermissions: Record<string, string | string[]> = {
  'Dashboard':              'GET /admin/analytics/*',
  'To-Do':                  ['GET /admin/trainerPendingRequest/*', 'GET /admin/trainerProfileupdate/*'],
  'Pending Verification':   'GET /admin/trainerPendingRequest/*',
  'Profile Picture Update Request': 'GET /admin/trainerProfileupdate/*',
  'Profile Change Logs':    'GET /admin/trainerProfileupdate/*',
  'Users':                  ['GET /admin/user/*', 'POST /admin/auth/register'],
  'User List':              'GET /admin/user/*',
  'Create User':            'POST /admin/auth/register',
  'School Management':      'GET /admin/vendor/*',
  'Vehicle Category':       'GET /admin/category/*',
  'Bookings':               'GET /admin/booking/*',
  'Booking List':           'GET /admin/booking/get-bookings-list',
  'Change Trainer History': 'GET /admin/booking/trainer-changing/*',
  'Booking Tracking':       'GET /admin/gps/*',
  'Reassignment Issues':    'GET /admin/booking/auto-reassign/*',
  'Reassignment History':   'GET /admin/booking/auto-reassign-history/*',
  'Assistant Bookings':     'GET /admin/booking/assistant/*',
  'Payouts':                ['GET /admin/payout/*', 'GET /v2/admin/payout/*'],
  'Trainer Payouts':        'GET /admin/payout/*',
  'Payout Requests':        ['GET /admin/payout/*', 'GET /v2/admin/payout/*'],
  'Student Wallet Balances':['GET /v2/admin/wallet/*', 'GET /admin/wallet/*'],
  'Withdrawal Requests':    ['GET /admin/withdrawals*', 'GET /v2/admin/withdrawals*'],
  'Certificate':            'GET /admin/certificate-request/*',
  'Awaiting Certificate':   'GET /admin/certificate-request/*',
  'Approved Certificate':   'GET /admin/certificate-request/*',
  'Reports & Analytics':    'GET /admin/reports/*',
  'Booking Report':         'GET /admin/reports/*',
  'Revenue Report':         'GET /admin/reports/*',
  'Trainer Report':         'GET /admin/reports/*',
  'Student Report':         'GET /admin/reports/*',
  'School Report':          'GET /admin/reports/*',
  'Package Management':     'GET /admin/package/*',
  'All-in-One Package':     'GET /admin/all-in-one/*',
  'Bundles':                'GET /admin/all-in-one/*',
  'Enrollments':            'GET /admin/all-in-one/*',
  'Coupon Management':      'GET /admin/discount/*',
  'Service Registrations':  'GET /admin/dynamic-service/*',
  'Home Slider':            ['GET /admin/slider/*', 'GET /admin/sliders/*'],
  'Reviews':                'GET /admin/reviews/*',
  'Trainer Reviews':        'GET /admin/reviews/*',
  'Student Reviews':        'GET /admin/reviews/*',
  'Notifications':          'GET /admin/notification/*',
  'Support':                ['GET /admin/support/*', 'GET /v2/admin/chat/*'],
  'Delete Users':           'GET /admin/user/tracking*',
  'Roles & Permissions':    ['GET /admin/role/*', 'GET /v2/admin/rbac/*', 'GET /v2/admin/role/*'],
  'Roles & Access':         ['GET /admin/role/*', 'GET /v2/admin/rbac/*', 'GET /v2/admin/role/*'],
  'User Roles':             ['GET /v2/admin/rbac/*', 'GET /admin/role/*'],
  'System Settings':        ['GET /admin/city/*', 'GET /admin/state-province/*', 'GET /admin/dialect/*', 'GET /admin/appSetting/*', 'GET /admin/user/languages*'],
  'Languages':              'GET /admin/user/languages*',
  'Cities':                 'GET /admin/city/*',
  'States':                 'GET /admin/state-province/*',
  'Dialects':               'GET /admin/dialect/*',
  'Pickup Time Restriction':'GET /admin/cityPickupExclusion/*',
  'App Settings':           'GET /admin/appSetting/*',
  'Terms & Conditions':     'GET /admin/appSetting/*',
  'Dynamic Services':       'GET /admin/dynamic-service/*',
  'Auto-Reassign':          'GET /admin/booking/auto-reassign/*',
}

/** Admin menu with every item the user has no permission for removed (and emptied parents dropped). */
export function filterAdminNav(sections: NavSection[], can: (perm: string | string[] | undefined) => boolean): NavSection[] {
  const keep = (items: NavItem[]): NavItem[] =>
    items.flatMap((item): NavItem[] => {
      if (item.children?.length) {
        const children = keep(item.children)
        return children.length ? [{ ...item, children }] : []
      }
      return can(adminNavPermissions[item.label]) ? [item] : []
    })
  return sections.map(s => ({ ...s, items: keep(s.items) })).filter(s => s.items.length > 0)
}

/** Every leaf nav item with its permission — used to guard direct URLs. */
export function flattenNav(sections: NavSection[]): NavItem[] {
  const out: NavItem[] = []
  const walk = (items: NavItem[]) => items.forEach(i => { out.push(i); if (i.children) walk(i.children) })
  sections.forEach(s => walk(s.items))
  return out
}

// School-admin sidebar — mirrors the original dashboard's `schooladminRoutes`
// (layouts/dashboard/config-navigation.tsx) item-for-item and in the same order.
// OVERVIEW items are always shown (never permission-filtered), exactly like the
// original, which added them outside `filterRoutesByPermission`.
export const schoolAdminNav: NavSection[] = [
  {
    section: 'OVERVIEW',
    items: [
      { label: 'Dashboard',     path: '/school/overview',            icon: 'LayoutDashboard' },
      { label: 'Support',       path: '/school/support',             icon: 'HeadphonesIcon' },
    ],
  },
  {
    section: 'MANAGEMENT',
    items: [
      { label: 'To-Do', path: '/school/todo/verification', icon: 'CheckSquare' },
      { label: 'My School',    path: '/school/account',             icon: 'School' },
      { label: 'Certificates', path: '/school/awaiting-certificate', icon: 'BadgeCheck', children: [
          { label: 'Awaiting Certificate', path: '/school/awaiting-certificate', icon: '' },
          { label: 'Approved Certificate', path: '/school/approved-certificate', icon: '' },
      ]},
      { label: 'Notifications', path: '/school/notifications', icon: 'Bell' },
      { label: 'Trainers', path: '/school/trainers-list', icon: 'Users', children: [
          { label: 'Trainer List',        path: '/school/trainers-list', icon: '' },
          { label: 'Add New Trainer',     path: '/school/new-trainer',   icon: '' },
          { label: 'Trainer Notifications', path: '/school/notifications', icon: '' },
      ]},
      { label: 'Commission', path: '/school/commission/trainer', icon: 'Percent' },
      { label: 'Package Management', path: '/school/package-list',   icon: 'Package' },
      { label: 'Bookings',           path: '/school/booking/list',   icon: 'Calendar' },
      { label: 'Booking Session Requests', path: '/school/booking/session-requests', icon: 'CalendarClock' },
      { label: 'Reassignment History', path: '/school/booking/auto-reassign-history', icon: 'History' },
      { label: 'Reviews', path: '/school/review/trainer', icon: 'Star', children: [
          { label: 'Trainer Reviews', path: '/school/review/trainer', icon: '' },
          { label: 'Student Reviews', path: '/school/review/student', icon: '' },
      ]},
      { label: 'Reports & Analytics', path: '/school/report/bookings', icon: 'BarChart2', children: [
          { label: 'Booking Report', path: '/school/report/bookings', icon: '' },
          { label: 'Revenue Report', path: '/school/report/revenue',  icon: '' },
          { label: 'Trainer Report', path: '/school/report/trainer',  icon: '' },
          { label: 'Student Report', path: '/school/report/student',  icon: '' },
          { label: 'School Report',  path: '/school/report/school',   icon: '' },
      ]},
      // Shown for every school admin (see ALWAYS_VISIBLE); the API enforces who may change what.
      { label: 'Roles & Permissions', path: '/school/roles/list', icon: 'Shield' },
    ],
  },
]

// ── School-admin permission visibility ───────────────────────────────────────
// Mirrors the original `schoolAdminRoutePermissionMap` + `filterRoutesByPermission`.
// Keyed by the nav label. An item is shown when the school admin holds at least
// one of its required permissions; a parent stays if it has any visible child.
// OVERVIEW is never filtered. Safe fallback: when the user has NO school-admin
// permissions attached, the full menu is shown (matches the original's
// `hasSchoolAdminRoles ? filtered : schooladminRoutes`).
const schoolAdminPermissionMap: Record<string, string> = {
  'To-Do':                 'request_for_verification_by_school_admin',
  'Pending Verification':  'request_for_verification_by_school_admin',
  'Pending Refund':        'request_for_verification_by_school_admin',
  'My School':             'my_school_school_admin',
  'Certificates':          'certificate_school_admin',
  'Awaiting Certificate':  'certificate_school_admin',
  'Approved Certificate':  'certificate_school_admin',
  'Notifications':         'notification_school_admin',
  'Trainers':              'trainer_list_school_admin',
  'Trainer List':          'trainer_list_school_admin',
  'Add New Trainer':       'trainer_list_school_admin',
  'Trainer Notifications': 'notification_school_admin',
  'Commission':            'commission_list_school_admin',
  'Package Management':    'package_list_school_admin',
  'School Payout':         'payout_school_admin',
  'Bookings':              'booking_school_admin',
  'Booking Session Requests': 'booking_school_admin',
  'Reviews':               'review_school_admin',
  'Trainer Reviews':       'review_school_admin',
  'Student Reviews':       'review_school_admin',
  'Reports & Analytics':   'report_school_admin',
  'Booking Report':        'report_school_admin',
  'Revenue Report':        'report_school_admin',
  'Trainer Report':        'report_school_admin',
  'Student Report':        'report_school_admin',
  'School Report':         'report_school_admin',
}

// Items with no school-admin permission name of their own — never filtered out.
const ALWAYS_VISIBLE = new Set(['Roles & Permissions'])

function filterItemsByPermission(items: NavItem[], permissions: Set<string>): NavItem[] {
  return items
    .map((item) => {
      const required = schoolAdminPermissionMap[item.label]
      const hasPermission = ALWAYS_VISIBLE.has(item.label) || (required ? permissions.has(required) : false)

      if (item.children?.length) {
        const children = filterItemsByPermission(item.children, permissions)
        if (hasPermission || children.length > 0) return { ...item, children }
        return null
      }
      return hasPermission ? item : null
    })
    .filter((x): x is NavItem => Boolean(x))
}

/**
 * Returns the school-admin nav filtered by the given permission names.
 * OVERVIEW is always kept. When `permissions` is empty the full menu is
 * returned unchanged (safe fallback, identical to the original behaviour).
 */
export function getSchoolAdminNav(permissions: string[] | undefined): NavSection[] {
  const set = new Set(permissions ?? [])
  if (set.size === 0) return schoolAdminNav
  return schoolAdminNav
    .map((section) =>
      section.section === 'OVERVIEW'
        ? section
        : { ...section, items: filterItemsByPermission(section.items, set) }
    )
    .filter((section) => section.items.length > 0)
}
